import BaseContent from './Base';

const TextContent = props => (
    <BaseContent {...props} type="text" />
);

export default TextContent;
